"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This is a numeric enum because of some specific unique circumstances (the
// roles function as indices into an array of values in some code, sorta like a
// dictionary but a bit different), and it was created before the tslint rule.
// Probably we should convert to a string enum.
// tslint:disable-next-line:prefer-string-enums
var MetricValueRole;
(function (MetricValueRole) {
    MetricValueRole[MetricValueRole["CURRENT"] = 0] = "CURRENT";
    MetricValueRole[MetricValueRole["ABSOLUTE_CHANGE"] = 1] = "ABSOLUTE_CHANGE";
    MetricValueRole[MetricValueRole["PERCENTAGE_CHANGE"] = 2] = "PERCENTAGE_CHANGE";
})(MetricValueRole = exports.MetricValueRole || (exports.MetricValueRole = {}));
var DateTrunc;
(function (DateTrunc) {
    DateTrunc["YEAR"] = "YEAR";
    DateTrunc["QUARTER"] = "QUARTER";
    DateTrunc["MONTH"] = "MONTH";
    DateTrunc["DAY"] = "DAY";
    DateTrunc["HOUR"] = "HOUR";
    DateTrunc["MINUTE"] = "MINUTE";
    DateTrunc["SECOND"] = "SECOND";
    DateTrunc["WEEK"] = "WEEK";
    DateTrunc["ISO_YEAR"] = "ISO_YEAR";
    DateTrunc["ISO_QTR"] = "ISO_QTR";
    DateTrunc["ISO_WEEK"] = "ISO_WEEK";
    DateTrunc["ISO_WEEKDAY"] = "ISO_WEEKDAY";
    DateTrunc["UNKNOWN"] = "UNKNOWN";
    DateTrunc["NONE"] = "NONE";
})(DateTrunc = exports.DateTrunc || (exports.DateTrunc = {}));
exports.detailTypes = [
    MetricValueRole.ABSOLUTE_CHANGE,
    MetricValueRole.PERCENTAGE_CHANGE,
];
exports.listTypes = [
    MetricValueRole.CURRENT,
    MetricValueRole.ABSOLUTE_CHANGE,
    MetricValueRole.PERCENTAGE_CHANGE,
];
//# sourceMappingURL=models.js.map